
        var result = require("!!../../node_modules/css-loader/index.js!./app.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = 482
// module chunks = 2